import { Suspense, useRef } from 'react';
import { useAtomValue } from 'jotai';
import { searchHelperFilterAtom } from '../../states/searchHelperFilter.atom';
import { usePopularKeywords } from '../../queries/usePopularKeywords';
import { PopularKeywordHeader } from '../PopularKeywordHeader/PopularKeywordHeader';
import { AgeFilter } from '../AgeFilter/AgeFilter';
import { PopularKeywordList } from '../PopularKeywordList/PopularKeywordList';
import { SearchType } from 'shared/src/api/enums';

type Props = {
  onSelectKeyword: (keyword: string, searchType: SearchType) => Promise<void>;
};

// Suspense 쿼리를 사용하는 내부 컴포넌트
// 데이터 로드 후 updatedAt ref를 갱신하여 헤더가 최신 값을 유지
const PopularKeywordContent = ({
  onSelectKeyword,
  updatedAtRef,
}: Props & { updatedAtRef: React.MutableRefObject<string> }) => {
  const ageFilter = useAtomValue(searchHelperFilterAtom);
  const { data: keywordsData } = usePopularKeywords(ageFilter.selectedAge);

  updatedAtRef.current = keywordsData.reference_time;

  return (
    <PopularKeywordList
      keywords={keywordsData.queries}
      onPress={k => {
        if (k.query) onSelectKeyword(k.query, SearchType.POPULAR);
      }}
    />
  );
};

// 자체 Suspense boundary로 감싸서 상위 리렌더 방지
export const PopularSection = ({ onSelectKeyword }: Props) => {
  const updatedAtRef = useRef('');

  return (
    <>
      <PopularKeywordHeader updatedAt={updatedAtRef.current} />
      <AgeFilter />
      <Suspense>
        <PopularKeywordContent
          onSelectKeyword={onSelectKeyword}
          updatedAtRef={updatedAtRef}
        />
      </Suspense>
    </>
  );
};
